module.exports = __webpack_public_path__ + "static/img/sheqianping.7ee6893.png";


//////////////////
// WEBPACK FOOTER
// ./static/sheqianping.png
// module id = lflQ
// module chunks = 1